import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import {
  Hotel,
  ReceiptIndianRupee,
  RefreshCcwDot,
  ShieldCheck,
  ShieldX,
  Tickets,
  UserRoundPlus,
} from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import { Pagination } from "react-bootstrap";
import dropdown from "../assets/arrow_drop_down_24px.svg";
import {
  computeplussevendays,
  computeTodayDate,
  formatDateStringdot,
  handleError,
} from "../CommonJquery/CommonJquery.js";
import {
  Analytics_text,
  options_select_drop_feedback,
} from "../CommonJquery/WebsiteText.js";
import {
  get_admin_dashboard_data,
  server_post_data,
} from "../ServiceConnection/serviceconnection.js";
import Header from "./Header.js";
import Loader from "./Loader.js";
import dayjs from "dayjs";

function DynamicBarChart({ selectedPeriod, CardData, barGraphData }) {
  const [chartData, setChartData] = useState([]);
  const [yAxisLabels, setYAxisLabels] = useState([]);

  useEffect(() => {
    const data = Object.entries(barGraphData || {}).map(([key, sales]) => {
      const isDateFormat = /^\d{4}-\d{2}-\d{2}$/.test(key);
      return {
        name: isDateFormat ? dayjs(key).format("D MMM") : key,
        sales: Number(sales) || 0,
      };
    });

    setChartData(data);

    const maxSales = Math.max(...data.map((item) => item.sales), 0);
    const roundedMax = Math.ceil(maxSales / 1000) * 1000;
    const step = Math.ceil(roundedMax / 5 / 1000) * 1000;
    const labels = Array.from({ length: 6 }, (_, i) => step * i);
    setYAxisLabels(labels);
  }, [barGraphData]);

  const maxSales = Math.max(...chartData.map((item) => item.sales), 0);
  const maxYAxisValue =
    yAxisLabels.length > 0 ? Math.max(...yAxisLabels) : maxSales || 1000;

  return (
    <div className="sales-graph">
      <h5 className="mb-4">Sales Performance</h5>
      <div className="position-relative">
        <div
          className="y-axis-labels"
          style={{
            position: "absolute",
            left: "0",
            top: "20px",
            bottom: "20px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          {yAxisLabels.reverse().map((value, index) => (
            <div
              key={index}
              style={{ fontSize: "12px", color: "#666", marginRight: "10px" }}
            >
              ₹{value.toLocaleString()}
            </div>
          ))}
        </div>

        <div
          style={{
            position: "absolute",
            left: "50px",
            bottom: "20px",
            width: "1px",
            height: "200px",
            backgroundColor: "#333",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            left: "50px",
            right: "20px",
            bottom: "20px",
            height: "1px",
            backgroundColor: "#333",
          }}
        ></div>

        <div
          className="graph-container"
          style={{
            marginLeft: "50px",
            marginTop: "20px",
            height: "220px",
            display: "flex",
            alignItems: "flex-end",
          }}
        >
          {chartData.map((item, index) => {
            const barHeightPercentage =
              maxYAxisValue > 0 ? item.sales / maxYAxisValue : 0;
            const barHeight = barHeightPercentage * 220;

            return (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: `${100 / chartData.length}%`,
                  height: "100%",
                  justifyContent: "flex-end",
                }}
              >
                <div
                  style={{ fontSize: "12px", color: "#666", fontWeight: "500" }}
                >
                  ₹{item.sales.toLocaleString()}
                </div>
                <div
                  style={{
                    width: "60%",
                    height: `${barHeight}px`,
                    backgroundColor: "#ffc107",
                    borderRadius: "4px 4px 0 0",
                    transition: "height 0.5s ease",
                    marginTop: "8px",
                  }}
                ></div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#333",
                    fontWeight: "500",
                    textAlign: "center",
                  }}
                >
                  {item.name}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

function Dashboard() {
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [customDateActive, setCustomDateActive] = useState(false);
  const [CalenderStartDate, setCalenderStartDate] = useState();
  const [CalenderEndDate, setCalenderEndDate] = useState();
  const [isActive, setIsActive] = useState(false);
  const [selected, setIsSelected] = useState(options_select_drop_feedback[0]);
  const [CardData, setCardData] = useState({});
  const [filteredData, setfilteredData] = useState([]);
  const [bestperRes, setbestPerRes] = useState([]);
  const [barGraphData, setbarGraphData] = useState({});

  const [startDate, setStartDate] = useState(computeplussevendays());
  const [endDate, setEndDate] = useState(computeTodayDate());
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Ref for the main dashboard content (for screenshot)
  const dashboardContentRef = useRef(null);

  const cardMetrics = [
    {
      title: "Total Restaurants",
      key: "total_Restaurant",
      icon: <Hotel size={24} />,
    },
    {
      title: "Total Restaurant without Subscription",
      key: "owner_listsss",
      icon: <ShieldX size={24} color="red" />,
    },
    {
      title: "Total Restaurant with Subscription",
      key: "total_spacial_booking",
      icon: <ShieldCheck size={24} color="green" />,
    },
    {
      title: "Total Revenue",
      key: "total_revenue_generate",
      icon: <ReceiptIndianRupee size={24} color="brown" />,
    },
    {
      title: "Account for Renewal",
      key: "acc_renewal",
      icon: <RefreshCcwDot size={24} color="#333" />,
    },
    {
      title: "Total Tickets",
      key: "new_ticket",
      icon: <Tickets size={24} color="#EDBD04" />,
    },
    {
      title: "Total New Onboarding",
      key: "new_onboarding",
      icon: <UserRoundPlus size={24} color="#EDBD04" />,
    },
  ];

  // FIXED: Download only dashboard content (not entire page)
  const handleDownloadButtonClick = async () => {
    if (!dashboardContentRef.current) return;

    setshowLoaderAdmin(true);

    const element = dashboardContentRef.current;
    const totalHeight = element.scrollHeight;
    const totalWidth = element.scrollWidth;

    // A4 size in pixels at 1x scale (we'll use scale 2 for quality)
    const pageHeight = 595.28 * 2; // A4 height in px at scale 2
    const pageWidth = 841.89 * 2; // A4 width in px (landscape if needed)

    let pdf = new jsPDF("p", "pt", "a4");
    let position = 0;

    // Temporary make full content visible
    const originalStyle = element.style.cssText;
    element.style.height = "auto";
    element.style.maxHeight = "none";
    element.style.overflow = "visible";
    element.style.paddingBottom = "100px"; // extra space at bottom

    try {
      let canvas;
      let imgData;
      let remainingHeight = totalHeight;

      while (remainingHeight > 0) {
        // Scroll to current position (important!)
        element.scrollTop = position;

        canvas = await html2canvas(element, {
          scale: 2,
          useCORS: true,
          allowTaint: true,
          scrollY: -position,
          scrollX: 0,
          windowWidth: totalWidth,
          windowHeight: totalHeight,
          height: Math.min(pageHeight, remainingHeight * 2), // capture only needed part
          logging: false,
        });

        imgData = canvas.toDataURL("image/png");

        if (position > 0) {
          pdf.addPage();
        }

        pdf.addImage(
          imgData,
          "PNG",
          0,
          0,
          595.28,
          Math.min(pageHeight / 2, canvas.height / 2)
        );

        position += pageHeight / 2; // move down by one A4 page
        remainingHeight -= pageHeight / 2;
      }

      pdf.save(`Uprestro_Analytics_${dayjs().format("DD-MMM-YYYY")}.pdf`);
    } catch (error) {
      console.error("PDF Error:", error);
      alert("PDF banane mein error aayi. Please try again.");
    } finally {
      // Restore original styles
      element.style.cssText = originalStyle;
      window.scrollTo(0, 0);
      setshowLoaderAdmin(false);
    }
  };

  useEffect(() => {
    master_data_get("", "", "1", "", "last_7_days"); // default load
  }, []);

  const master_data_get = async (
    start_date,
    end_date,
    flag,
    call_id,
    select_type
  ) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    const current_date = new Date();

    if (select_type === "today") {
      start_date = formatDate(current_date);
      end_date = formatDate(current_date);
    } else if (select_type === "last_7_days") {
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 6);
      start_date = formatDate(sevenDaysAgo);
      end_date = formatDate(current_date);
    } else if (select_type === "this_month") {
      start_date = formatDate(
        new Date(current_date.getFullYear(), current_date.getMonth(), 1)
      );
      end_date = formatDate(
        new Date(current_date.getFullYear(), current_date.getMonth() + 1, 0)
      );
    } else if (select_type === "last_month") {
      start_date = formatDate(
        new Date(current_date.getFullYear(), current_date.getMonth() - 1, 1)
      );
      end_date = formatDate(
        new Date(current_date.getFullYear(), current_date.getMonth(), 0)
      );
    } else if (select_type === "this_year") {
      start_date = formatDate(new Date(current_date.getFullYear(), 0, 1));
      end_date = formatDate(current_date);
    }

    function formatDate(date) {
      return date.toISOString().split("T")[0];
    }

    setCalenderStartDate(start_date);
    setCalenderEndDate(end_date);

    fd.append("start_date", start_date);
    fd.append("end_date", end_date);
    fd.append("flag", flag);
    fd.append("call_id", call_id);
    fd.append("select_type", select_type);

    try {
      const Response = await server_post_data(get_admin_dashboard_data, fd);
      if (Response.data.error) {
        handleError(Response.data.message);
      } else {
        const data = Response.data.message;
        setCardData(data || {});
        setfilteredData(data.reservation_list || []);
        setbestPerRes(data.top_performing_restaurants || []);
        setbarGraphData(data.bar_graph_data || {});
      }
    } catch (error) {
      handleError("network");
    } finally {
      setshowLoaderAdmin(false);
    }
  };

  // FIXED: Validate To Date >= From Date
  const search_data = () => {
    if (new Date(endDate) < new Date(startDate)) {
      alert("End Date cannot be earlier than Start Date!");
      return;
    }
    master_data_get(startDate, endDate, "1", "", selected.value);
  };

  const select_dropdown = (itemsdata) => {
    setIsSelected(itemsdata);
    setIsActive(false);

    if (itemsdata.datepicker_show) {
      setCustomDateActive(true);
    } else {
      setCustomDateActive(false);
      master_data_get("", "", "1", "", itemsdata.value);
    }
  };

  const totalItems = filteredData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const currentItems = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const dropdownRef = useRef(null);
  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsActive(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="dashboard darbord_contrrr">
      {showLoaderAdmin && <Loader />}

      {/* This div will be captured in screenshot */}
      <div ref={dashboardContentRef} className="dashboard_container">
        <div className="page_content">
          <div className="page_content_container">
            <Header />

            <div className="pageCntn_head">
              <div className="analyticsHead">
                <div className="analyticFIlter">
                  <div className="col-xl-10">
                    <div className="row m-0 align-items-end">
                      <div className="col-md-4">
                        <div className="dropdownCustom" ref={dropdownRef}>
                          <div
                            onClick={() => setIsActive(!isActive)}
                            className="dropdownCustom-btn"
                          >
                            {Analytics_text.Period_text}: {selected.label}
                            <span
                              className={
                                isActive
                                  ? "fas fa-caret-up"
                                  : "fas fa-caret-down"
                              }
                            >
                              <img src={dropdown} alt="dropdown" />
                            </span>
                          </div>
                          {isActive && (
                            <div className="dropdownCustom-content">
                              {options_select_drop_feedback.map(
                                (items, index) => (
                                  <div
                                    onClick={() => select_dropdown(items)}
                                    className="itemDrop"
                                    key={index}
                                  >
                                    {items.label}
                                  </div>
                                )
                              )}
                            </div>
                          )}
                        </div>
                      </div>

                      {customDateActive && (
                        <>
                          <div className="col-md-3">
                            <input
                              type="date"
                              value={startDate}
                              onChange={(e) => setStartDate(e.target.value)}
                              max={computeTodayDate()}
                              className="form-control input_field_custom4"
                            />
                          </div>
                          <div className="col-md-3">
                            <input
                              type="date"
                              value={endDate}
                              onChange={(e) => setEndDate(e.target.value)}
                              max={computeTodayDate()}
                              className="form-control input_field_custom4"
                            />
                          </div>
                          <div className="col-md-2">
                            <button
                              onClick={search_data}
                              className="downloadBtnAna btn btn-primary"
                            >
                              {Analytics_text.Search_text}
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <div className="downloadBtnAna">
                  <button onClick={handleDownloadButtonClick}>
                    {Analytics_text.download_text}
                  </button>
                </div>
              </div>
            </div>

            <div className="page_body">
              <div className="analytics">
                <div className="analytics_container">
                  {/* Metric Cards - Removed hardcoded "Total Sales of 1 outlets" */}
                  <div className="row g-4 mb-4">
                    {cardMetrics.map(({ title, key, icon }, index) => (
                      <div
                        className={`col-lg-${
                          index < 4 ? "3" : "4"
                        } col-md-6 col-sm-6 col-12`}
                        key={key}
                      >
                        <div
                          className={`metric-card ${
                            index < 4 ? "small-card" : ""
                          }`}
                        >
                          <div className="d-flex justify-content-between align-items-start">
                            <div>
                              <h6 className="metric-title">{title}</h6>
                              <h3 className="metric-value">
                                {CardData[key] || 0}
                              </h3>
                            </div>
                            <div className="metric-icon">{icon}</div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="mb-4">
                    <DynamicBarChart
                      selectedPeriod={selected.value}
                      CardData={CardData}
                      barGraphData={barGraphData}
                    />
                  </div>

                  {/* Top Performing Restaurants */}
                  <div className="feedBackTable">
                    <div className="feedBackTable_container">
                      <h5>Top Performance Restaurant</h5>
                      <div className="tableResponsive">
                        <table className="display table">
                          <thead>
                            <tr>
                              <th>Position</th>
                              <th>Restaurant Name</th>
                              <th>Sales</th>
                            </tr>
                          </thead>
                          <tbody>
                            {bestperRes && bestperRes.length > 0 ? (
                              bestperRes.map((item, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{item.outlet_name}</td>
                                  <td>₹{item.total_sales}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="3">No data available</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  {/* Recently Onboarded */}
                  <div className="feedBackTable mt-4">
                    <div className="feedBackTable_container">
                      <h5>Recently Onboarded Restaurant</h5>
                      <div className="tableResponsive">
                        <table className="display table">
                          <thead>
                            <tr>
                              <th>S.No.</th>
                              <th>Entry Date</th>
                              <th>Owner Name</th>
                              <th>Restaurant Name</th>
                              <th>City</th>
                              <th>Country</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentItems.map((item, index) => (
                              <tr key={index}>
                                <td>
                                  {(currentPage - 1) * itemsPerPage + index + 1}
                                </td>
                                <td>{formatDateStringdot(item.entry_date)}</td>
                                <td>{item.restaurant_owner_name || "-"}</td>
                                <td>{item.restaurant_name}</td>
                                <td>{item.restaurant_city}</td>
                                <td>{item.restaurant_country}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {totalPages > 1 && (
                        <Pagination>
                          <Pagination.Prev
                            onClick={() =>
                              setCurrentPage((p) => Math.max(1, p - 1))
                            }
                            disabled={currentPage === 1}
                          />
                          {[...Array(totalPages)].map((_, i) => (
                            <Pagination.Item
                              key={i + 1}
                              active={i + 1 === currentPage}
                              onClick={() => setCurrentPage(i + 1)}
                            >
                              {i + 1}
                            </Pagination.Item>
                          ))}
                          <Pagination.Next
                            onClick={() =>
                              setCurrentPage((p) => Math.min(totalPages, p + 1))
                            }
                            disabled={currentPage === totalPages}
                          />
                        </Pagination>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
